import { TextEditor } from './TextEditor'
import { InfoPanel as View } from 'ui-components'
import { useMap } from '~map-preview/states/map'

function InfoPanel() {
  const map = useMap()
  return (
    <View
      isOpenByDefault={map && map.readme?.isOpenByDefault}
      slots={{ TextEditor }}
    />
  )
}

export { InfoPanel }
